import { useEffect, useState } from "react";
import "../css/search.css";
import Head from "./head";
import { SearchContainer } from "./header";
import { useSearchParams } from "react-router-dom";

export default function NotFound() {
   var [ param, setParam ] = useSearchParams();

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);

   return (

      <main id="not-found" className="guides-animation">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "website",
            title: "Page Not Found - MerlinDB",
            description: "",
            page_author: "Chris Axxwell",
            index: "noindex, nofollow, noarchive",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados",
            canonical: "",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg", //imagem que ta dentro de src/files/images/head/
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg", //o icone da pagina em /src/files/
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
            //redirect: ["https://www.chrisaxxwell.com", 3], //redireciona a pagina para outra pagina ou outro dominio depois de 3 segundos ou nao defina para 0
         }} />

         <div>
            <h1>Page Not Found</h1>
            <h2>The page you're looking for can't be found.</h2>
            <h4>You can search for the content below:</h4>
            <SearchContainer setSearch={setParam} />
         </div>
      </main >
   )
} 